/*
 *
 * LoginPage reducer
 *
 */
import produce from 'immer';
import {
  ADD_NEW_DEVICE_ACTIONTYPE,
  ADD_RELATIVE_ACTIONTYPE,
  CHANGE_OWNER_ACTIONTYPE,
  CHANGE_OWNER_ANYDEVICE_ACTIONTYPE,
  CHANGE_SELECTED_DEVICE_ACTIONTYPE,
  CLONE_DEVICE_ACTIONTYPE,
  DELELTE_DEVICE_ACTIONTYPE,
  DELETE_OWNER_ANYDEVICE_ACTIONTYPE,
  DELETE_RELATIVE_ACTIONTYPE,
  GET_ALL_DEVICES_ACTIONTYPE,
  GET_DEVICE_DETAIL_ACTIONTYPE,
  GET_DEVICES_FOR_USER_ACTIONTYPE,
  GET_OWNED_DEVICE_FOR_UUID_ACTIONTYPE,
  HANDLE_DEVICE_SOLD_ACTIONTYPE, OWNED_DEVICE_CALL_SUCCESS_ACTIONTYPE,
  RESET_DEVICE_ACTIONTYPE,
  SEND_SIGNAL_TO_WATCH_ACTIONTYPE,
  SHOW_LOCATION_POPOVER_FOR_DEVICE_ACTIONTYPE,
  SHOW_MONITORING_POPOVER_FOR_DEVICE_ACTIONTYPE,
  UPDATE_DEVICE_ACTIONTYPE,
  UPDATE_DEVICE_LABEL_ACTIONTYPE,
} from './actionTypes';
import { LOGGED_OUT_ACTIONTYPE, RESET_APP_DATA_ACTIONTYPE } from '../../appContainer/actionTypes';

export const initialState = {
  all: [],
  owned: [],
  selected: {},
  monitoringPopover: '',
  locationPopover: '',
  ownedDevicesCallSuccess: false
};

/* eslint-disable default-case, no-param-reassign */
const devicesReducer = produce((draft, action) => {
  switch (action.type) {
    case GET_ALL_DEVICES_ACTIONTYPE.SUCCESS: {
      draft.all = action.payload;
      break;
    }
    case OWNED_DEVICE_CALL_SUCCESS_ACTIONTYPE.COMPLETED: {
      draft.ownedDevicesCallSuccess = action.payload;
      break;
    }
    case GET_DEVICES_FOR_USER_ACTIONTYPE.SUCCESS: {
      draft.owned = action.payload;
      break;
    }
    case ADD_NEW_DEVICE_ACTIONTYPE.SUCCESS: {
      const newDevice = action.payload;
      const devices = [...draft.all];
      devices.push(newDevice);
      draft.all = devices;
      break;
    }
    case CHANGE_SELECTED_DEVICE_ACTIONTYPE.COMPLETED: {
      draft.selected = action.payload;
      break;
    }
    case DELELTE_DEVICE_ACTIONTYPE.SUCCESS: {
      const deviceUUID = action.payload;
      const deviceIndex = draft.all.findIndex(device => device.uuid === deviceUUID);

      if (deviceIndex !== -1) {
        draft.all.splice(deviceIndex, 1);
      }
      break;
    }
    case GET_DEVICE_DETAIL_ACTIONTYPE.SUCCESS: {
      const newDevice = action.payload;
      const allDevices = [...draft.owned];
      const deviceIndex = allDevices.findIndex(device => device.uuid === newDevice.uuid);
      if (deviceIndex !== -1) {
        allDevices.splice(deviceIndex, 1);
      }
      allDevices.push(newDevice);
      draft.owned = allDevices;
      break;
    }
    case UPDATE_DEVICE_LABEL_ACTIONTYPE.SUCCESS:
    case ADD_RELATIVE_ACTIONTYPE.SUCCESS:
    case DELETE_RELATIVE_ACTIONTYPE.SUCCESS:
    case CHANGE_OWNER_ACTIONTYPE.SUCCESS:
    case UPDATE_DEVICE_ACTIONTYPE.SUCCESS: {
      const updatedDevice = action.payload;
      const allDevices = [...draft.owned];
      const deviceIndex = allDevices.findIndex(device => device.uuid === updatedDevice.uuid);
      if (deviceIndex !== -1) {
        allDevices.splice(deviceIndex, 1, updatedDevice);
        draft.selected = updatedDevice;
        draft.owned = allDevices;
      }
      break;
    }
    case DELETE_OWNER_ANYDEVICE_ACTIONTYPE.SUCCESS:
    case CHANGE_OWNER_ANYDEVICE_ACTIONTYPE.SUCCESS: {
      const updatedDevice = action.payload;
      const allDevices = [...draft.all];
      const deviceIndex = allDevices.findIndex(device => device.uuid === updatedDevice.uuid);
      if (deviceIndex !== -1) {
        allDevices.splice(deviceIndex, 1, updatedDevice);
      }
      draft.all = allDevices;
      break;
    }
    case HANDLE_DEVICE_SOLD_ACTIONTYPE.SUCCESS: {
      const { uuid, newStatus } = action.payload;
      const currentDevice = draft.all.find(device => device.uuid === uuid);
      if (currentDevice) {
        currentDevice.isSold = newStatus;
        draft.all = [...draft.all];
      }
      const ownedDevice = draft.owned.find(device => device.uuid === uuid);
      if (ownedDevice) {
        ownedDevice.isSold = newStatus;
        draft.owned = [...draft.owned];
      }
      break;
    }
    case GET_OWNED_DEVICE_FOR_UUID_ACTIONTYPE.SUCCESS: {
      const newDevices = action.payload || [];
      const existingDevicesMap = {};
      const newAllDevices = [...draft.all];
      newAllDevices.forEach(device => {
        existingDevicesMap[device.uuid] = true;
      });
      newDevices.forEach(device => {
        if (!existingDevicesMap[device.uuid]) {
          newAllDevices.push(device);
        }
      });
      draft.all = newAllDevices;
      draft.owned = newDevices;
      break;
    }
    case SHOW_MONITORING_POPOVER_FOR_DEVICE_ACTIONTYPE.COMPLETED: {
      draft.monitoringPopover = action.payload;
      break;
    }
    case SHOW_LOCATION_POPOVER_FOR_DEVICE_ACTIONTYPE.COMPLETED: {
      draft.locationPopover = action.payload;
      break;
    }
    case RESET_DEVICE_ACTIONTYPE.SUCCESS:
    case CLONE_DEVICE_ACTIONTYPE.SUCCESS:
    case SEND_SIGNAL_TO_WATCH_ACTIONTYPE.SUCCESS: {
      const updatedDevice = action.payload || {};
      if (!Object.keys(updatedDevice).length) {
        break;
      }
      const allDevicesIndex = (draft.all || []).findIndex(device => device.uuid === updatedDevice.uuid);
      const ownDeviceIndex = (draft.owned || []).findIndex(device => device.uuid === updatedDevice.uuid);
      if (allDevicesIndex !== -1) {
        const allDevices = [...draft.all];
        allDevices.splice(allDevicesIndex, 1, updatedDevice);
        draft.all = allDevices;
      }
      if (ownDeviceIndex !== -1) {
        const allDevices = [...draft.all];
        allDevices.splice(allDevicesIndex, 1, updatedDevice);
        draft.owned = allDevices;
      }
      if (draft.selected.uuid === updatedDevice.uuid) {
        draft.selected = updatedDevice;
      }
      break;
    }
    case LOGGED_OUT_ACTIONTYPE.SUCCESS:
    case RESET_APP_DATA_ACTIONTYPE.TRIGGER:
      return initialState;
  }
}, initialState);

export default devicesReducer;
